import ErrorMessage from "@medoma/components/ErrorMessage/ErrorMessage";
import { Loading } from "@medoma/components/Loading/Loading";
import { hasAuthParams, useAuth } from "react-oidc-context";
import { Navigate } from "react-router";
import * as Sentry from "@sentry/react";
import { deducedError } from "@/Utils/ErrorUtils";
import { Link } from "@medoma/components/Link/Link";
import styles from "./IdsLogin.module.scss";
import { Trans, useLingui } from "@lingui/react/macro";

export const FROM_LOGIN = "from-login";

const LoginLayout = ({ children }: { children: React.ReactNode }) => {
  return <div className={styles.loginLayout}>{children}</div>;
};

const START_PAGE = "/";
export const Login = () => {
  const { t } = useLingui();
  const { activeNavigator, isLoading, isAuthenticated, error, user } =
    useAuth();

  if (isAuthenticated) {
    const urlBeforeAuthRoundTrip = user?.state;

    const subBeforeAuthRoundTrip = user?.url_state;
    const subAfterAuthRoundTrip = user?.profile.sub;
    const newUserSignedIn = subBeforeAuthRoundTrip !== subAfterAuthRoundTrip;

    const redirectTo = !urlBeforeAuthRoundTrip
      ? START_PAGE
      : newUserSignedIn
        ? START_PAGE
        : urlBeforeAuthRoundTrip;

    return <Navigate to={redirectTo} replace state={FROM_LOGIN} />;
  }

  if (activeNavigator || isLoading) {
    return (
      <LoginLayout>
        <Loading message={t`Loggar in`} />
      </LoginLayout>
    );
  }

  if (error) {
    Sentry.captureException(error);
    if (hasAuthParams()) {
      Sentry.captureException(
        "User ended up in an error state with preserved auth params",
      );
    }
    return (
      <LoginLayout>
        <ErrorMessage
          message={`${t`Det gick inte att logga in.`} ${deducedError(error)}`}
        />
        {hasAuthParams() ? (
          <Link to="/">
            <Trans>Gå till startsidan</Trans>
          </Link>
        ) : null}
      </LoginLayout>
    );
  }

  // MED-4737: Sign out from pin-screen in Go
  // Before, this returned `null`, and then the user got stuck with a blank screen.
  // Now, we redirect to the root for Auth to take over.
  return <Navigate to="/" replace state={FROM_LOGIN} />;
};
